import { CommonModule } from '@angular/common'
import { Component, Input, Output, EventEmitter } from '@angular/core'
import { RouterModule } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { MatStepperModule } from '@angular/material/stepper'
import { MatIconModule } from '@angular/material/icon'

@Component({
  selector: 'app-stages-history',
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipe,
    MatStepperModule,
    MatIconModule
  ],
  standalone: true,
  templateUrl: './stages-history.html',
  styleUrl: './stages-history.scss'
})
export class StagesHistory {
  @Input() stagesList: any[] = []
  @Output() selectStage = new EventEmitter<any>()
  @Input() stageNote: any
  currentLanguage = localStorage.getItem('lang')

  getStageNotes(value: any) {
    const index = value.selectedIndex
    this.stageNote = []
    this.selectStage.emit(this.stagesList[index].id)
  }
}
